import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { POINT_LOG_TYPES } from '../../constants';
import { getLabelByValue, formatDateTimeDisplay, formatChallengePointMessage } from '../../utils/base';

export const RewardHistoryItem = ({ item, showSign = true }) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();

    // type이 1 또는 2인 경우 차감으로 처리
    const isDeduction = item.type === 1 || item.type === 2;

    // 포인트 타입에 따른 색상 결정
    const getPointColor = (point) => {
        if (isDeduction) {
            return theme.palette.figma.downBlue;
        }
        return point > 0 ? theme.palette.figma.upRed : theme.palette.figma.downBlue;
    };

    // 포인트 타입에 따른 부호 결정
    const getPointSign = (point) => {
        if (isDeduction) {
            return '-';
        }
        return point > 0 ? '+' : '';
    };

    return (
        <Box
            sx={{
                borderBottom: '1px dashed ' + theme.palette.figma.white[30],
                padding: '10px 20px',
                minHeight: 'auto',
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                columnGap: 2,
                rowGap: 1.5,
                minWidth: 0,
            }}
        >
            <Stack spacing={0.5} sx={{ flex: '1 1 0', minWidth: 0, maxWidth: '100%' }}>
                <Typography
                    sx={{
                        fontSize: '14px',
                        fontWeight: 500,
                        color: theme.palette.figma.white[80],
                        letterSpacing: '-0.42px',
                        textAlign: 'left',
                        whiteSpace: 'normal',
                        wordBreak: 'keep-all',
                        overflowWrap: 'break-word',
                    }}
                >
                    {item.message ? formatChallengePointMessage(item.message, t, i18n, item) : t('point_transaction')}
                </Typography>
                {item.userName && (
                    <Typography
                        sx={{
                            fontSize: '12px',
                            fontWeight: 400,
                            color: theme.palette.figma.white[60],
                            letterSpacing: '-0.36px',
                            textAlign: 'left',
                            whiteSpace: 'normal',
                            wordBreak: 'keep-all',
                            overflowWrap: 'break-word',
                        }}
                    >
                        {item.userName}
                    </Typography>
                )}
                <Typography
                    sx={{
                        fontSize: '12px',
                        fontWeight: 400,
                        color: theme.palette.figma.white[60],
                        letterSpacing: '-0.36px',
                        textAlign: 'left',
                    }}
                >
                    {formatDateTimeDisplay(item.time, 'datetime')}
                </Typography>
            </Stack>
            <Stack
                spacing={0.5}
                alignItems="flex-end"
                sx={{
                    flexShrink: 0,
                    minWidth: 0,
                    maxWidth: '100%',
                    ml: 'auto',
                }}
            >

                <Typography
                    sx={{
                        fontSize: '14px',
                        fontWeight: 600,
                        color: getPointColor(item.point),
                        letterSpacing: '-0.42px',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {showSign && (getPointSign(item.point))}{item.point?.toLocaleString()} P
                </Typography>
                <Typography
                    sx={{
                        fontSize: '12px',
                        fontWeight: 400,
                        color: theme.palette.figma.white[60],
                        letterSpacing: '-0.36px',
                        textAlign: 'right',
                        whiteSpace: 'normal',
                        wordBreak: 'keep-all',
                        overflowWrap: 'break-word',
                        maxWidth: '100%',
                    }}
                >
                    {(() => { const lbl = getLabelByValue(POINT_LOG_TYPES, item.type); return lbl ? t(lbl) : t('complete'); })()}
                </Typography>
            </Stack>
        </Box>
    );
};

export default RewardHistoryItem;

